import React from "react";
import Button from "../../../../_components/Button";
import TableData from "../../../../_components/TableData";
import Text from "../../../../_components/Text";
import Modal from "../../../../_components/Modal";
import IconButton from "../../../../_components/IconButton";

import { toast } from "react-toastify";

import moment from "moment/moment";

import {
  onGetDefaultStartEnDate,
  getMonthRange,
  MONTH_NAMES_SHORT,
} from "./helpers";

import {
  getNFeBatch,
  createNFeBatch,
  syncBacth,
  downloadBatch,
} from "../../../../api/nfe";
import DatePicker from "react-datepicker";
import { donwloadBase64, formatDate } from "../../../../utils";

// Barra moderna animada para o status de processamento
var RowProgressBar = function(props) {
  if (!props.active) return null;
  return (
    <div style={{
      width: "100%",
      minWidth: "80px",
      height: "4px",
      background: "rgba(0,0,0,0.06)",
      borderRadius: "4px",
      overflow: "hidden",
      marginTop: "6px",
    }}>
      <div style={{
        height: "100%",
        width: "100%",
        background: "linear-gradient(90deg, #ffc107 0%, #fff3cd 50%, #ffc107 100%)",
        backgroundSize: "200% 100%",
        animation: "nfe-premium-pulse 1.5s infinite linear",
        borderRadius: "4px"
      }} />
    </div>
  );
};

var barKeyframes = `
@keyframes nfe-premium-pulse {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
`;
var styleTag = document.createElement("style");
styleTag.innerHTML = barKeyframes;
document.head.appendChild(styleTag);

const IconLoading = ({
  loadingIcon = "fas fa-spinner fa-pulse",
  defaultIcon = "sync",
  onClickAction,
}) => {
  const [waiting, setWaiting] = React.useState(false);

  const onClick = () => {
    setWaiting(true);
    return onClickAction()
      .then(() => {})
      .catch((error) => { console.error("Error:", error); })
      .finally(() => {
        setTimeout(() => { setWaiting(false); }, 1000);
      });
  };

  if (waiting) {
    return (
      <span className="mx-2">
        <i className={loadingIcon} />
      </span>
    );
  }
  return (
    <span className="mx-2">
      <IconButton onClick={onClick} icon={defaultIcon} />
    </span>
  );
};

export default (props) => {
  const [rawData, setRawData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [show, setShow] = React.useState(false);
  const [activeBatches, setActiveBatches] = React.useState({});
  const ref = React.useRef(null);
  const [selectedMonth, setSelectedMonth] = React.useState(new Date().getMonth());
  const [feedback, setFeedbak] = React.useState({ type: "", text: "" });
  const [batch, setBatchData] = React.useState({
    start_date: null,
    end_date: null,
    minDate: null,
  });
  const [result, setResult] = React.useState({
    showModal: false,
    protocolNumber: "",
    totalDocuments: 0,
    nextUpdate: "",
  });

  var setActive = function(batchId, active) {
    setActiveBatches(function(prev) {
      var next = Object.assign({}, prev);
      if (active) {
        next[batchId] = true;
      } else {
        delete next[batchId];
      }
      return next;
    });
  };

  const onOpenModal = () => {
    const [currentStartDate, currentEndDate] = onGetDefaultStartEnDate();
    setBatchData({ start_date: moment(currentStartDate), end_date: moment(currentEndDate), minDate: null });
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setFeedbak({ text: "", type: "" });
  };

  const loadData = () => {
    getNFeBatch()
      .then((resp) => {
        setRawData(resp);
      })
      .catch(() => {});
  };

  const choiceMonth = (monthIndex) => {
    setSelectedMonth(monthIndex);
    const [start_date, end_date] = getMonthRange(monthIndex);
    setBatchData({ start_date: moment(start_date), end_date: moment(end_date), minDate: null });
  };

  const createBacth = () => {
    setFeedbak({ text: "", type: "" });
    setLoading(true);
    createNFeBatch(batch)
      .then((resp) => {
        handleClose();
        let newUpdate = new Date(resp.on_finish).toLocaleString("pt-BR", {
          day: "2-digit", month: "2-digit", year: "2-digit",
          hour: "2-digit", minute: "2-digit", hour12: false,
        });
        setResult({
          showModal: true,
          protocolNumber: resp.protocol_number,
          totalDocuments: resp.total_documents,
          nextUpdate: newUpdate,
        });
        var msUntilReady = Math.max(0, new Date(resp.on_finish) - new Date()) + 3000;
        setTimeout(function() { startSync(resp.id, resp.total_documents); }, msUntilReady);
      })
      .catch((error) => {
        if (error.batch_error && error.batch_error === "batch without results") {
          setFeedbak({ type: "danger", text: "Nenhuma NF-e encontrada nesse intervalo de datas." });
        }
      })
      .finally(() => {
        setTimeout(() => { setLoading(false); }, 2500);
      });
  };

  var startSync = function(batchId, totalDocuments) {
    setActive(batchId, true);
    syncBacth(batchId)
      .then(function(response) {
        if (response.ready) {
          var estimatedMs = Math.max(10000, Math.ceil((totalDocuments || 1) / 10) * 1500);
          setTimeout(function() { 
            setActive(batchId, false);
            loadData();
            tryDownload(batchId, 0); 
          }, estimatedMs);
        } else {
          setTimeout(function() { startSync(batchId, totalDocuments); }, 10000);
        }
      })
      .catch(function(error) {
        console.error("Erro no sync:", error);
        setTimeout(function() { startSync(batchId, totalDocuments); }, 15000);
      });
  };

  var tryDownload = function(batchId, attempt) {
    var maxAttempts = 5;
    downloadBatch(batchId)
      .then(function(resp) {
        if (resp.base64) {
          setActive(batchId, false);
          donwloadBase64(batchId, "zip", "", resp.base64);
          toast.success(
            <Text color="white">Download do lote concluído!</Text>,
            { position: "top-center", toastId: "batch-download-complete" }
          );
          setTimeout(function() { window.location.reload(); }, 3000);
        } else if (attempt < maxAttempts) {
          setTimeout(function() { tryDownload(batchId, attempt + 1); }, 15000);
        } else {
          setActive(batchId, false);
          toast.error(
            <Text color="white">Tempo esgotado. Tente baixar manualmente pela tabela.</Text>,
            { position: "top-center", toastId: "batch-download-error" }
          );
        }
      })
      .catch(function(error) {
        console.error("Erro no download:", error);
        if (attempt < maxAttempts) {
          setTimeout(function() { tryDownload(batchId, attempt + 1); }, 15000);
        } else {
          setActive(batchId, false);
        }
      });
  };

  const onSyncBatchStatus = (batchId) => {
    return new Promise((resolve, reject) => {
      setActive(batchId, true);
      syncBacth(batchId)
        .then((response) => {
          if (response.ready) {
            var estimatedMs = Math.max(10000, Math.ceil((response.totalDocuments || 1) / 10) * 1500);
            setTimeout(function() {
              toast.success(
                <Text color="white">Lote disponível. Iniciando download...</Text>,
                { position: "top-center", toastId: "batch-available" }
              );
              setActive(batchId, false);
              loadData();
              tryDownload(batchId, 0);
              resolve();
            }, estimatedMs);
          } else {
            toast.info(
              <Text color="white">Lote ainda não disponível. {response.next_update}</Text>,
              { position: "top-center", toastId: "batch-unavailable" }
            );
            setTimeout(() => { startSync(batchId, null); }, 10000);
            resolve(response);
          }
        })
        .catch((error) => { 
          console.error(error); 
          setActive(batchId, false);
          reject(error); 
        });
    });
  };

  const handleDownloadBatch = (batchId) => {
    return new Promise((resolve, reject) => {
      setActive(batchId, true);
      downloadBatch(batchId)
        .then((response) => {
          setActive(batchId, false);
          donwloadBase64(batchId, "zip", "", response.base64);
          resolve();
        })
        .catch((error) => {
          setActive(batchId, false);
          reject(error);
        });
    });
  };

  const handlerChangeEndDate = (value) => {
    setBatchData({ ...batch, end_date: value });
  };

  const closeModalResult = () => {
    setResult({ showModal: false, protocolNumber: "", totalDocuments: 0, nextUpdate: "" });
    window.location.reload();
  };

  React.useEffect(() => {
    loadData();
  }, [ref.current]);

  const data = React.useMemo(() => {
    return rawData.map((item) => ({
      ...item,
      start_date: formatDate(moment(item.start_date).add(1, 'seconds')),
      end_date: formatDate(moment(item.end_date).add(1, 'seconds')),
      status: item.status === 1
        ? (
          <div className="d-flex flex-column align-items-center">
            <span className="badge badge-warning">processando...</span>
            <RowProgressBar active={!!activeBatches[item.id]} />
          </div>
        )
        : <span className="badge badge-success">lote disponível</span>,
      created_date: (
        <div style={{ display: "flex", alignItems: "center" }}>
          {item.status === 1 ? (
            <React.Fragment>
              <IconLoading
                loadingIcon="fas fa-circle-notch fa-spin"
                defaultIcon="sync"
                onClickAction={() => onSyncBatchStatus(item.id)}
              />
            </React.Fragment>
          ) : (
            <React.Fragment>
              <IconLoading
                loadingIcon="fas fa-circle-notch fa-spin"
                defaultIcon="download"
                onClickAction={() => handleDownloadBatch(item.id)}
              />
            </React.Fragment>
          )}
          <span style={{ marginLeft: "4px" }}>
            {formatDate(moment(item.created_date).add(1, 'seconds'), true)}
          </span>
        </div>
      ),
    }));
  }, [rawData, activeBatches]);

  return (
    <div className="container-fluid" ref={ref}>
      <div className="row">
        <div className="col-12 py-4">
          <Text fontSize="md">Exportações em lote</Text>
          <Button onClick={onOpenModal}>Exportar novo lote de NF-e</Button>
        </div>
        <div className="col-12">
          <TableData
            tBodyKeys={["created_date", "status", "start_date", "end_date", "total_documents", "protocol_number"]}
            tHead={["Data da solicitação", "Status", "Data inicial", "Data final", "Qtd. de documentos", "Protocolo"]}
            data={data}
          />
        </div>
      </div>

      <Modal title="Exportar lote de NF-e" show={show} onHide={handleClose}>
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="form-group">
              <div className="form-label"><Text>Data inicial</Text></div>
              <DatePicker
                selected={batch.start_date}
                dateFormat="DD/MM/yyyy"
                onChange={(e) => { setSelectedMonth(null); setBatchData({ ...batch, start_date: e }); }}
                disabled={loading}
                className="form-control"
              />
            </div>
          </div>
          <div className="col-md-5">
            <div className="form-group">
              <div className="form-label"><Text>Data final</Text></div>
              <DatePicker
                selected={batch.end_date}
                maxDate={moment(new Date())}
                onChange={(v) => { setSelectedMonth(null); handlerChangeEndDate(v); }}
                dateFormat="DD/MM/yyyy"
                disabled={loading}
                className="form-control"
              />
            </div>
          </div>
        </div>
        <div className="row justify-content-center mt-1">
          <div className="col-md-10">
            <Text>Selecione um mês:</Text>
            <div className="row mt-2" style={{ margin: "0 -3px" }}>
              {MONTH_NAMES_SHORT.map((name, idx) => {
                const currentMonth = new Date().getMonth();
                const isFuture = idx > currentMonth;
                const isSelected = selectedMonth === idx;
                return (
                  <div className="col-4 col-md-2 px-1 mb-2" key={idx}>
                    <button
                      disabled={loading || isFuture}
                      onClick={() => choiceMonth(idx)}
                      style={{
                        width: "100%", padding: "7px 0", fontSize: "12px",
                        fontWeight: isSelected ? "700" : "500",
                        border: isSelected ? "2px solid #1a6896" : "1px solid #c4d9e8",
                        borderRadius: "6px",
                        cursor: isFuture || loading ? "not-allowed" : "pointer",
                        background: isSelected ? "#1a6896" : isFuture ? "#f5f5f5" : "#eaf3fb",
                        color: isSelected ? "#fff" : isFuture ? "#c0c0c0" : "#1a6896",
                        transition: "all 0.15s ease", outline: "none",
                      }}
                    >
                      {name}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <Text align="center" color={feedback.type}>{feedback.text}</Text>
        <div className="d-flex justify-content-center mt-3">
          <Button disabled={loading} onClick={createBacth}>Exportar lote</Button>
        </div>
      </Modal>

      <Modal
        title={"Protocolo de exportação gerado " + result.protocolNumber}
        show={result.showModal}
        onHide={closeModalResult}
      >
        <Text align="center" fontSize="md">Total de NF-e: {result.totalDocuments}</Text>
        <Text align="center" fontSize="md">Previsão de conclusão: {result.nextUpdate}</Text>
        <div className="d-flex justify-content-center my-3">
          <Button onClick={closeModalResult}>OK</Button>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/BatchNFe/index.jsx